// extracted by mini-css-extract-plugin
module.exports = {"eventos":"Eventos_eventos__2AOHu","carregador":"Eventos_carregador__pKbus","icone":"Eventos_icone__36EF8"};